import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22161 32047"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:459.808}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970277519904">
        <path
          d="M230 22915V9957l10850 8835 10851-8835v12958l-10851 8836z"
          className="fill stroke1s"
          style={{
            strokeWidth: 459.808,
          }}
        />
        <path
          d="M230 4713V484l10850 8835L21931 484v4229l-10851 8836z"
          className="fill stroke1s"
          style={{
            strokeWidth: 459.808,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
